<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Laporan Laba Declaring</v-card-title>
      <v-card-text><v-row>
        <v-col cols="12" md="2"><v-text-field v-model="filter.dari" type="date" label="Dari" dense /></v-col>
        <v-col cols="12" md="2"><v-text-field v-model="filter.sampai" type="date" label="Sampai" dense /></v-col>
        <v-col cols="12" md="3"><v-text-field v-model="filter.customer" label="Customer" dense /></v-col>
        <v-col cols="12" md="2"><v-btn color="primary" @click="fetchData">Tampilkan</v-btn></v-col>
      </v-row></v-card-text>
    </v-card>
    <v-row class="mt-2">
      <v-col v-for="card in cards" :key="card.key" cols="12" md="3"><v-card><v-card-text><div>{{card.label}}</div><h2>Rp {{money(summary[card.key])}}</h2></v-card-text></v-card></v-col>
    </v-row>
    <v-data-table class="mt-3" :headers="headers" :items="items" dense>
      <template v-slot:item.nilai_tagihan="{item}">Rp {{money(item.nilai_tagihan)}}</template>
      <template v-slot:item.total_realisasi="{item}">Rp {{money(item.total_realisasi)}}</template>
      <template v-slot:item.laba_bersih="{item}">Rp {{money(item.laba_bersih)}}</template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name:"LaporanDeclaring",
  data:()=>({filter:{dari:"",sampai:"",customer:""},items:[],summary:{},cards:[{key:"tagihan",label:"Total Tagihan"},{key:"realisasi",label:"Total Realisasi"},{key:"laba_bersih",label:"Laba Bersih"},{key:"piutang",label:"Piutang"}],headers:[{text:"No. SPK",value:"no_spk"},{text:"Customer",value:"nama_customer"},{text:"Pekerjaan",value:"pekerjaan"},{text:"Tagihan",value:"nilai_tagihan"},{text:"Realisasi",value:"total_realisasi"},{text:"Laba Bersih",value:"laba_bersih"},{text:"Status Bayar",value:"status_pelunasan"}]}),
  created(){this.fetchData();},
  methods:{money(v){return Number(v||0).toLocaleString("id-ID");},async fetchData(){try{const r=await axios.get("laporan-keuangan/declaring",{params:this.filter});this.items=r.data.items;this.summary=r.data.ringkasan;}catch(e){alert(e.response?.data?.message||"Gagal memuat laporan");}}}
};
</script>
